/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { imageUtil } from "@/common-components-src/js/utils/imageUtil";
import UKPageLoading from "@/common-components-src/components/UKPageLoading";
import UKPageNothing from "@/common-components-src/components/UKPageNothing";
import IntlRating from "./rating";
import styles from "../reviews.module.scss";
import Pagination from "@/app/csr-src/pages/order/components/pagination";

import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Response } from "@/app/csr-src/apis/api.interface";
import { MouseEvent, useEffect, useState } from "react";
import { styled as muiStyled } from "@mui/material/styles";
import { fetchUserReCommentList } from "@/app/csr-src/apis/profile/review.api";
import { WaitingReviewRes, SkuItem } from "@/app/csr-src/apis/profile/review.interface";
import ArrowRight from "@/app/csr-src/assets/icons/RightArrow.svg";
import WaitingReviewHeaderIcon from "@/app/csr-src/assets/icons/waitingReviewHeaderIcon.svg";
import { sendClickTrack as myReviewSendClickTrack, EXPOSURE_RECORD as MY_REVIEW_EXPOSURE_RECORD } from "@/tracks/25155";
import { sendClickTrack as reviewResultSendClickTrack, EXPOSURE_RECORD as REVIEW_RESULT_EXPOSURE_RECORD } from "@/tracks/25336"

interface OrderItem {
  label: string;
  value: string;
}

interface BannerView {
  linkUrl?: string;
  text?: string;
}

export const ReviewButton = muiStyled(Button)(({ theme }) => ({
  fontSize: "14px",
  padding: "7px 16px",
  borderRadius: "4px",
  lineHeight: "18px",
  textAlign: "center",
  fontWeight: 400,
  border: "1px solid #E0E1E5",
  color: "#1A1A1A",
  "&:hover": {
    background: "none",
    boxShadow: "none",
  },
  "&.Mui-disabled": {
    opacity: 0.5,
    cursor: "no-drop",
    color: "#888",
  },
}));
export default function WaitingReview({ onScrollTop, skuIdListFn, pageType = undefined }: { onScrollTop?: () => void; skuIdListFn?: any; pageType?: string | undefined }) {
  const navigate = useNavigate();
  const [data, setData] = useState<WaitingReviewRes[]>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [bannerView, setBannerView] = useState<BannerView>({
    linkUrl: "",
    text: "",
  });

  const [paginationData, setPaginationData] = useState<{ currentPage: number; pageSize: number }>({
    currentPage: 1,
    pageSize: 10,
  });

  const [total, setTotal] = useState<number>(0);

  const init = async () => {
    setIsLoading(true);
    const res = await fetchUserReCommentList(paginationData);
    const { data: dataList = [], total } = res || {};
    setData(dataList);
    if (dataList && dataList?.length > 0) {
      const commentSkuList: any = dataList?.map((item: any) => {
        if (item?.commentSkuList && item?.commentSkuList?.length > 0) {
          return item.commentSkuList[0];
        }
      });
      if (commentSkuList && commentSkuList.length > 0) {
        const skuIdList: any = commentSkuList.flat().map((item: any, index: number) => {
          if (index <= 10 && item.skuId) {
            return item.skuId;
          }
        });
        skuIdListFn?.(skuIdList.join(","));
      }
    } else {
      skuIdListFn?.("");
    }
    setBannerView(res?.bannerView || { linkUrl: "", text: "" });
    setTotal(total ?? 0);
    setIsLoading(false);
    onScrollTop?.();
  };

  const goReview = (event: MouseEvent, orderId: string, skuIds: string) => {
    /** 点击事件上报-待评价tab下去评价按钮点击 */
    myReviewSendClickTrack.My_Reviews_WaitingReviews_List_Review({orderId: String(orderId), skuid: String(skuIds)})
    if (pageType && pageType === "reviewResult") {
      reviewResultSendClickTrack.Evaluate_CommentComplete_Reivew({ orderId: String(orderId), skuid: String(skuIds) })
    }
    event.preventDefault();
    event.stopPropagation();
    navigate(`/Review?orderId=${orderId}`);
  };

  // 单品跳转评价详情
  const goReviewSku = (event: MouseEvent, sku: string, orderId: string) => {
    event.preventDefault();
    event.stopPropagation();
    navigate(`/Review?orderId=${orderId}&skuId=${sku}`);
  };
  
  // 评分
  const onRatingChange = (num: number | null, skuId: string, orderId: string) => {
    /** 点击事件上报-待评价tab下列表评分点击 */
    myReviewSendClickTrack.My_Reviews_WaitingReviews_List_Star({orderId: String(orderId), skuid: String(skuId)})
    if (pageType && pageType === "reviewResult") {
      reviewResultSendClickTrack.Evaluate_CommentComplete_Score({ orderId: String(orderId), skuid: String(skuId) })
    }
    // 如果评分是5星，则跳转到评价页面
    navigate(`/Review?orderId=${orderId}&skuId=${skuId}&fullStar=${num}`);
  };

  const pagesChangeHandler = (page: number) => {
    window.scrollTo(0, 0); // 滚动到顶部
    const params = { ...paginationData };
    params.currentPage = page;
    setPaginationData(params);
  };
  // 点击卡片跳转商详
  const gotoOrderDetail = (orderId: string) => {
    location.href = `/profile/my-orders/order-details?orderId=${orderId}`;
  };

  // 跳转到 规则介绍落地页
  const goRulePage = () => {
    location.href = bannerView?.linkUrl as string;
  };

  useEffect(() => {
    init();
  }, [paginationData]);

  return (
    <div className={styles.orderWrapper}>
      {/* <div className={styles.banner_wrap}>
        <div className={styles.banner_item}>
          <WaitingReviewHeaderIcon style={{ cursor: "pointer" }} />
          <span>{bannerView?.text}</span>
        </div>
        <div className={styles.banner_item}>
          {false && (
            <>
              <span onClick={goRulePage} className={styles.banner_r_text}>
                View
              </span>
              <ArrowRight onClick={goRulePage} style={{ cursor: "pointer" }} />
            </>
          )}
        </div>
      </div> */}
      {isLoading && <UKPageLoading />}
      {!isLoading && !data?.length && (
        <div className={styles.pageEmpty}>
          <UKPageNothing text="There's nothing more" />
        </div>
      )}
      {data?.map((item: WaitingReviewRes, index: number) => {
        const { orderId, commentSkuList, beginTime } = item;
        return (
          <div className={styles.orderItem} key={index}>
            <div className={styles.header}>
              <div className={styles.colums1}>
                {[
                  { label: "Order ID:", value: orderId },
                  { label: "Order Time:", value: beginTime },
                ].map((order: OrderItem, index: number) => (
                  <div key={index} className={styles.item}>
                    <span>{order.label}</span>
                    <span>{order.value}</span>
                  </div>
                ))}
              </div>
              {/* 本次不展示金额 */}
              {/* <div className={styles.colums2}>
                <span className="label">{commentSkuList.length} item(s): </span>
                <JDIPrice
                  symbol={"￡"}
                  price={"1196.33"}
                  uiType={1}
                  integerStyle={{ fontSize: "16px" }}
                  containerStyle={{ lineHeight: "20px", fontSize: "16px" }}
                />
              </div> */}
            </div>
            <div className={styles.product}>
              <>
                {/* 单品跳转评价详情 */}
                {commentSkuList.map((sku: SkuItem, index: number) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                    /** 待评价tab下列表曝光 */ 
                    exptag={ pageType && pageType === "reviewResult" ? "exp|" + MY_REVIEW_EXPOSURE_RECORD.My_Reviews_WaitingReviews_List : "exp|" + REVIEW_RESULT_EXPOSURE_RECORD.Evaluate_CommentComplete_Score_Expo }
                    data-exptag-json-param={JSON.stringify({ orderId: `${orderId || '-100'}`, skuId: `${sku.skuId || '-100'}`})}
                    data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
                  >
                    <div className={styles.item} onClick={(event: MouseEvent) => goReviewSku(event, sku.skuId, orderId)}>
                      <div className={styles.colums1}>
                        <div className={styles.imgWrapper}>
                          {/* eslint-disable-next-line @next/next/no-img-element */}
                          <img src={imageUtil.concatImgUrlWithoutForceHttps(sku.skuImage, 60, 60, 70)} alt="" onClick={()=>{
                            myReviewSendClickTrack.My_Reviews_Picture({material_type: "1", commentId: String(sku?.commentId) || "-100" })
                          }}/>
                        </div>
                        <div className={styles.productTitle}>
                          <div className={styles.text}>{sku.skuTitle}</div>
                          <div className={styles.dimensions}>{sku.propertyExt}</div>
                        </div>
                      </div>
                    </div>
                    <div className={styles.starWrapper}>
                      <IntlRating value={null} onChange={(num) => onRatingChange(num, sku.skuId, orderId)} />
                    </div>
                  </div>
                ))}
              </>
              <>
                {/* 点击跳转到多品评价详情 */}
                {commentSkuList && commentSkuList.length > 1 && (
                  <>
                    <div className={styles.reviewButtonWrapper}>
                      <div className={styles.colums2}
                      exptag={ pageType && pageType === "reviewResult" ? "exp|" + MY_REVIEW_EXPOSURE_RECORD.My_Reviews_WaitingReviews_List_Review_Expo : "exp|" + REVIEW_RESULT_EXPOSURE_RECORD.Evaluate_CommentComplete_Reivew_Expo }
                      data-exptag-json-param={JSON.stringify({ orderId: `${orderId}`, skuId: `${commentSkuList.map(item=> item.skuId).join("") || "-100" }`})}
                      data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
                      >
                        <ReviewButton onClick={(event: MouseEvent) => goReview(event, orderId || "-100", commentSkuList.map(item=> item.skuId).join("#") || "-100")}>Review</ReviewButton>
                      </div>
                    </div>
                  </>
                )}
              </>
            </div>
          </div>
        );
      })}
      {total ? (
        <div className={styles.pagination_wrap}>
          <Pagination currentPage={paginationData.currentPage} totalPages={Math.ceil(total / 10)} handlePageChange={pagesChangeHandler} />
        </div>
      ) : null}
    </div>
  );
}
